import { Button } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { useNavigate } from 'react-router'

interface Props {
  isEdit: boolean
  onSubmit: () => Promise<void>
}
export const UserFormHeader = ({ isEdit, onSubmit }: Props) => {
  const navigate = useNavigate()
  const { t } = useTranslate()

  const action = isEdit ? t('editUser', 'Edit user') : t('addNewUser', 'Add new user')
  const breadCrumbs = [
    { label: t(PATHS.config.users.title), route: PATHS.config.users.url },
    { label: action },
  ]

  return (
    <Header
      title={action}
      breadcrumbs={breadCrumbs}
      position='relative'
      rightRenderOption={
        <>
          <Button
            variant='text'
            color='inherit'
            data-cy='cancel-user-btn'
            onClick={() => navigate(PATHS.config.users.url)}
          >
            {t('cancel', 'Cancel')}
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => onSubmit()}
            data-cy='user-save-btn'
          >
            {t('submit', 'Submit')}
          </Button>
        </>
      }
    />
  )
}
